/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Dialog_ConfirmingInputs */

const vi_await_dialog_confirming = /** @type {(inputs: Await_Dialog_ConfirmingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tạo đơn…`)
};

/**

* @param {Await_Dialog_ConfirmingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_dialog_confirming = /** @type {((inputs?: Await_Dialog_ConfirmingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Dialog_ConfirmingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_dialog_confirming(inputs)
});